import { Link } from "react-router-dom";
import { SolidorLogo } from "./SolidorLogo";
import { useLang } from "@/i18n";

const safeUpper = (text, lang) =>
  String(text || "").toLocaleUpperCase(
    lang === "tr" ? "tr-TR" : "en-US"
  );

export const Footer = () => {
  const { lang, t } = useLang();

  return (
    <footer
      data-testid="site-footer"
      className="bg-ink text-white"
    >
      <div className="px-5 sm:px-10 pt-20 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-6">
          <div className="md:col-span-5 flex flex-col gap-6">
            <SolidorLogo
              className="h-14 self-start"
              color="#FFFFFF"
            />

            <p className="font-mono text-[11px] tracking-[0.35em] text-white/60">
              ARCHITECTURE &amp; DESIGN
            </p>
          </div>

          <div className="md:col-span-3 flex flex-col gap-3 text-sm font-light text-white/70">
            <span className="font-mono text-[10px] tracking-[0.3em] text-white/40 mb-2">
              {safeUpper(
                t.footer.studio,
                lang
              )}
            </span>

            <span>
              {t.footer.location}
            </span>

            <a
              href="mailto:hello@solidor.studio"
              data-testid="footer-email-link"
              className="hover:text-white transition-colors duration-300"
            >
              hello@solidor.studio
            </a>

            <a
              href="https://instagram.com"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram-link"
              className="hover:text-white transition-colors duration-300"
            >
              Instagram
            </a>
          </div>

          <div className="md:col-span-4 flex flex-col gap-3 text-sm font-light text-white/70">
            <span className="font-mono text-[10px] tracking-[0.3em] text-white/40 mb-2">
              {safeUpper(
                t.footer.index,
                lang
              )}
            </span>

            <Link
              to="/studio"
              data-testid="footer-link-studio"
              className="hover:text-white transition-colors duration-300"
            >
              {t.nav.studio}
            </Link>

            <Link
              to="/services"
              data-testid="footer-link-services"
              className="hover:text-white transition-colors duration-300"
            >
              {t.nav.services}
            </Link>

            <Link
              to="/contact"
              data-testid="footer-link-contact"
              className="hover:text-white transition-colors duration-300"
            >
              {t.nav.contact}
            </Link>
          </div>
        </div>

        <div className="mt-20 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 font-mono text-[10px] tracking-[0.3em] text-white/40">
          <span data-testid="footer-copyright">
            © SOLIDOR
          </span>

          <span>
            solidor.studio
          </span>
        </div>
      </div>
    </footer>
  );
};
